document.addEventListener("DOMContentLoaded", () => {
  const googleReviews = document.getElementById("grp-entangle--root");

  if (!googleReviews) {
    return;
  }

  const observer = new MutationObserver((mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.type !== "childList") {
        continue;
      }

      const mutatedChild = mutation.target;

      if (
        mutatedChild.nodeName !== "DIV" &&
        !mutatedChild.classList.contains("grp-entangle-swiper-container")
      ) {
        continue;
      }

      const ratingsContainers = mutatedChild.querySelectorAll(
        "div.grp-entangle-rating"
      );

      if (!ratingsContainers) {
        return;
      }

      for (const ratingsContainer of ratingsContainers) {
        const goldStars = ratingsContainer.querySelectorAll(
          '.grp-entangle-rating svg[style^="fill:#F7BB04"]'
        );

        const grayStars = ratingsContainer.querySelectorAll(
          '.grp-entangle-rating svg[style^="fill:gray"]'
        );

        goldStars.forEach((goldStar) => {
          styleGoldStars(goldStar);
        });

        if (!grayStars) {
          continue;
        }

        grayStars.forEach((grayStar) => {
          styleGrayStars(grayStar);
        });
      }
    }
  });

  observer.observe(googleReviews, { subtree: true, childList: true });

  const reviewStarColor = "#23375C";

  const styleGoldStars = (goldStar) => {
    goldStar.style.fill = reviewStarColor;
  }
  
  const styleGrayStars = (grayStar) => {
    grayStar.style.fill = "none";
    grayStar.style.stroke = reviewStarColor;
    grayStar.style.strokeWidth = "10";
    grayStar.style.transform = "scale(0.9)";
  }

});

